module.exports = __webpack_public_path__ + "img/type-tpm.678d800d.png";